import * as React from 'react';
import {
  MobilePreviewContainer,
  CourseGrid,
  CourseCard,
  PosterImage,
  CoverImage,
  CourseInfo,
  CourseTitle,
  CourseDescription,
  PreviewMode,
  ModeSelector,
  DeviceFrame
} from './MobilePreview.style';

export interface Course {
  id: string;
  title: string;
  description: string;
  cover?: {
    uri: string;
    uri_original?: string;
  };
  poster?: {
    uri: string;
    uri_original?: string;
  };
}

interface MobilePreviewProps {
  courses?: Course[];
  mode?: 'poster' | 'cover' | 'both';
}

export const MobilePreview: React.FC<MobilePreviewProps> = ({ 
  courses = [], 
  mode = 'both' 
}) => {
  const [currentMode, setCurrentMode] = React.useState<'poster' | 'cover' | 'both'>(mode);
  const [selectedCourse, setSelectedCourse] = React.useState<Course | null>(null);

  // Mock data caso não tenha cursos
  const mockCourses: Course[] = React.useMemo(() => [
    {
      id: '1',
      title: 'Treino Funcional Avançado',
      description: 'Exercícios funcionais para melhorar força e resistência',
      cover: { uri: '/images/default-courses.png' },
      poster: { uri: '/images/default-courses.png' }
    },
    {
      id: '2', 
      title: 'Yoga para Iniciantes',
      description: 'Posturas básicas e técnicas de respiração',
      cover: { uri: '/images/default-courses-2.png' },
      poster: { uri: '/images/default-courses-2.png' }
    },
    {
      id: '3',
      title: 'Musculação Feminina',
      description: 'Programa específico para mulheres',
      cover: { uri: '/images/default-courses-3.png' },
      poster: { uri: '/images/default-courses-3.png' }
    },
    {
      id: '4',
      title: 'HIIT Intensivo',
      description: 'Treino intervalado de alta intensidade',
      cover: { uri: '/images/default-courses-4.png' },
      poster: { uri: '/images/default-courses-4.png' }
    }
  ], []);

  const displayCourses = courses.length > 0 ? courses : mockCourses;

  const renderCourseCard = (course: Course) => (
    <CourseCard 
      key={course.id}
      onClick={() => setSelectedCourse(course)}
      className={selectedCourse?.id === course.id ? 'selected' : ''}
    >
      {currentMode === 'poster' && course.poster && (
        <PosterImage
          src={course.poster.uri}
          alt={course.title}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = '/images/default-courses.png';
          }}
        />
      )}
      
      {currentMode === 'cover' && course.cover && (
        <CoverImage
          src={course.cover.uri}
          alt={course.title}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = '/images/default-courses.png';
          }}
        />
      )}

      {currentMode === 'both' && (
        <>
          {course.poster && (
            <PosterImage
              src={course.poster.uri}
              alt={`${course.title} - Poster`}
              loading="lazy"
              onError={(e) => {
                e.currentTarget.src = '/images/default-courses.png';
              }}
            />
          )}
          {course.cover && (
            <CoverImage
              src={course.cover.uri}
              alt={`${course.title} - Cover`}
              loading="lazy"
              style={{ marginTop: '8px' }}
              onError={(e) => {
                e.currentTarget.src = '/images/default-courses.png';
              }}
            />
          )}
        </>
      )}

      <CourseInfo>
        <CourseTitle>{course.title}</CourseTitle>
        <CourseDescription>{course.description}</CourseDescription>
      </CourseInfo>
    </CourseCard>
  );

  return (
    <MobilePreviewContainer>
      <h2>Preview Mobile - Estilo Netflix</h2>
      
      <ModeSelector>
        <button 
          onClick={() => setCurrentMode('poster')}
          className={currentMode === 'poster' ? 'active' : ''}
        >
          Apenas Poster
        </button>
        <button 
          onClick={() => setCurrentMode('cover')}
          className={currentMode === 'cover' ? 'active' : ''}
        >
          Apenas Cover
        </button>
        <button 
          onClick={() => setCurrentMode('both')}
          className={currentMode === 'both' ? 'active' : ''}
        >
          Ambos
        </button>
      </ModeSelector>

      <DeviceFrame>
        <PreviewMode>
          Modo: {currentMode === 'poster' ? 'Poster (2:3)' : 
                 currentMode === 'cover' ? 'Cover (16:9)' : 
                 'Poster + Cover'}
        </PreviewMode>
        
        <CourseGrid mode={currentMode}>
          {displayCourses.map(renderCourseCard)}
        </CourseGrid>
      </DeviceFrame>

      {selectedCourse && (
        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
          <h3>Curso Selecionado:</h3>
          <p><strong>Título:</strong> {selectedCourse.title}</p>
          <p><strong>Descrição:</strong> {selectedCourse.description}</p>
          <p><strong>Cover URL:</strong> {selectedCourse.cover?.uri || 'N/A'}</p>
          <p><strong>Poster URL:</strong> {selectedCourse.poster?.uri || 'N/A'}</p>
        </div>
      )}
    </MobilePreviewContainer>
  );
};
